import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import UnimplementedCatch from './UnimplementedCatch';

/**
 * Used to abstract dynamic component layouts in Aspect
 *
 */
const ComponentMapRender = ({ componentMap, content, depth = 0 }) => {
  const {
    publicRuntimeConfig: { showDebuggerOnLoad },
  } = getConfig();

  if (showDebuggerOnLoad === 'true' && typeof window !== 'undefined') {
    window.componentList = Object.keys(componentMap);
  }

  return content.map(({ component, children = undefined, ...rest }, i) => {
    if (!(component in componentMap)) {
      return (
        <UnimplementedCatch
          component={component}
          componentProps={rest}
          // eslint-disable-next-line react/no-array-index-key
          key={`unknown-${component}-${i}`}
        />
      );
    }

    const Component = componentMap[component];

    if (Component.contentRender) {
      if (Array.isArray(children))
        return Component.contentRender(
          {
            children: (
              <ComponentMapRender
                componentMap={componentMap}
                depth={depth + 1}
                content={children}
                // eslint-disable-next-line react/no-array-index-key
                key={`${i}-childof-${component}`}
              />
            ),

            ...rest,
          },
          { componentMap, Render: ComponentMapRender },
        );

      return Component.contentRender(
        { ...(children && { children }), ...rest },
        { componentMap, Render: ComponentMapRender },
      );
    }

    if (Array.isArray(children))
      return (
        // eslint-disable-next-line react/no-array-index-key
        <Component {...rest} key={`${component}-${i}-${depth}`}>
          {children.length ? (
            <ComponentMapRender
              componentMap={componentMap}
              depth={depth + 1}
              content={children}
              // eslint-disable-next-line react/no-array-index-key
              key={`${i}-childof-${component}`}
            />
          ) : (
            undefined
          )}
        </Component>
      );

    return <Component key={`${component}-0-${depth}`} {...rest}>{children}</Component>;
  });
};

ComponentMapRender.propTypes = {
  componentMap: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  content: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  depth: PropTypes.number,
};

export default ComponentMapRender;
